import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

// Fallback static story
const staticStories = [
  {
    id: 1,
    title: 'La rinascita di Baloo',
    content: 'Trovato denutrito e spaventato ai margini di una statale, Baloo tremava ad ogni rumore. Nei primi mesi al canile è stato difficile conquistare la sua fiducia. Ma con pazienza e tanti bocconcini, oggi è un cane completamente trasformato.',
    difficulties: 'Paura degli estranei e malnutrizione.',
    character: 'Adesso è il re delle coccole da divano.',
    progress: 'Ha imparato ad andare al guinzaglio e adora i bambini.',
    quote: 'Come Baloo, ci sono tanti altri cani che aspettano solo il loro divano e la loro famiglia. Fai la differenza, adotta!',
    image: '/images/story_dog_1776854143096.png'
  }
];

function Stories() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchStories() {
      try {
        const { data, error } = await supabase.from('success_stories').select('*').order('id', { ascending: false });
        
        if (error) {
          console.error('Error fetching stories from Supabase:', error);
          setStories(staticStories);
        } else if (data && data.length > 0) {
          setStories(data);
        } else {
          setStories(staticStories);
        }
      } catch (err) {
        console.error('Error in fetch:', err);
        setStories(staticStories);
      } finally {
        setLoading(false);
      }
    }

    fetchStories();
  }, []);

  return (
    <section className="stories section" id="le-storie">
      <div className="container">
        <h2 className="section-title">Le loro storie</h2>
        <p className="section-subtitle">Il lieto fine è possibile: guarda la trasformazione di chi ha già trovato una famiglia che lo ama.</p>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>Caricamento storie...</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
            {stories.map(story => (
              <div className="story-card animate-on-scroll" key={story.id}>
                <div className="story-image">
                  <img src={story.image} alt={story.title} />
                </div>
                <div className="story-content">
                  <h3 style={{ fontSize: '32px', marginBottom: '16px' }}>{story.title}</h3>
                  <p style={{ color: 'var(--color-text-light)', marginBottom: '24px' }}>
                    {story.content}
                  </p>
                  <ul style={{ marginBottom: '32px', lineHeight: '2' }}>
                    <li>✅ <strong>Difficoltà superate:</strong> {story.difficulties}</li>
                    <li>✅ <strong>Carattere:</strong> {story.character}</li>
                    <li>✅ <strong>Progressi:</strong> {story.progress}</li>
                  </ul>
                  <div style={{ backgroundColor: '#F9F6F0', padding: '24px', borderRadius: '16px' }}>
                    <p style={{ fontStyle: 'italic', margin: 0 }}>
                      "{story.quote}"
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default Stories;
